// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const generateDynamicGridItemStyle = (numberOfItemsInRow: number, numberOfItemsInRowForMobile = 1) => {
    return {
        width: [
            12,
            12 / numberOfItemsInRowForMobile,
            12 / numberOfItemsInRowForMobile,
            12 / numberOfItemsInRow,
            12 / numberOfItemsInRow,
        ],
    } as any;
};

export const setClipboardText = (text: string) => {
    const id = "mycustom-clipboard--hidden-id";
    let existsClipboardElement = document.getElementById(id);

    if (!existsClipboardElement) {
        const clipboardElement = document.createElement("textarea");
        clipboardElement.id = id;
        // Place in top-left corner of screen regardless of scroll position.
        clipboardElement.style.position = "fixed";
        clipboardElement.style.top = "-999px";
        clipboardElement.style.left = "-999px";

        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        clipboardElement.style.width = "1px";
        clipboardElement.style.height = "1px";

        // We don't need padding, reducing the size if it does flash render.
        clipboardElement.style.padding = "0px";

        // Clean up any borders.
        clipboardElement.style.border = "none";
        clipboardElement.style.outline = "none";
        clipboardElement.style.boxShadow = "none";

        // Avoid flash of white box if rendered for any reason.
        clipboardElement.style.background = "transparent";
        document.querySelector("body")!.appendChild(clipboardElement);

        existsClipboardElement = document.getElementById(id);
    }

    (existsClipboardElement as any)!.value = text;
    (existsClipboardElement as any)!.select();

    try {
        const status = document.execCommand("copy");
        if (!status) {
            // Cannot copy text

            (existsClipboardElement as any).parentNode.removeChild(existsClipboardElement);
            return false;
        }

        (existsClipboardElement as any).parentNode.removeChild(existsClipboardElement);
        // The text is now on the clipboard
        return true;
    } catch (err) {
        (existsClipboardElement as any).parentNode.removeChild(existsClipboardElement);
        // Unable to copy.
        return false;
    }
};
